import React, { Component } from 'react';
import Docs from "../docs/docs";
import mondaySdk from "monday-sdk-js";
import classes from "./main-grid.module.scss";
import { isDocs, getSessionToken } from '../../services/backend-service';
import EncryptionWizard from '../encryption-wizard/encryption-wizard';
import { Flex } from "monday-ui-react-core";

class MainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      context: props.context || {},
      userId: null,
      isGuest: true,
      isViewOnly: true,
      userId: -1
    };
  }

  componentDidMount() {
    const monday = mondaySdk();

    monday.listen("context", (res) => {
      this.setState({
        isGuest: res.data.user.isGuest,
        isViewOnly: res.data.user.isViewOnly,
        userId: res.data.user.id
      });
    });
  }

  render() {
    if(isDocs() || !getSessionToken()) {
      return <Docs />;
    } else {
      if(this.state.isViewOnly || this.state.isGuest) {
        return(
          <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}>
              <div className={classes.emptyStateComponent}>
                <div className={classes.emptyStateContainer}>
                  <img className={classes.permissionsImg} alt="Grand permissions" src="/monday/ecv/v1/config/images/empty-set.png" />
                </div>
                <div className={classes.ctaContainer}>
                  <div className={classes.ctaContainerTitle}>Something's Missing</div>
                  <div className={classes.ctaContainerSubtitle}>Your current role doesn't allow access here. Please reach out if you think this is a mistake.</div>
                </div>
              </div>
            </Flex>
          </Flex>
        );
      }

      return <EncryptionWizard/>;
    }
  }
}

export default MainGrid;
